import { memo } from 'react';

import { useGetHomeTemplate } from 'app/modules/Parameters/HomeTemplate/hooks/useGetHomeTemplate';
import { Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

// eslint-disable-next-line react/display-name
export const HomeTemplate = memo(() => {
  const { t, i18n } = useTranslation();

  const { data, error, loading, execute } = useGetHomeTemplate(i18n.language, 'home-template');
  if (error || loading) {
    return <></>;
  }
  const currentTemplate = data?.template;

  // Use dangerouslySetInnerHTML for React 19 compatibility
  return (
    <Row>
      <div className="col-12 col-sm-10 offset-sm-1">
        <div dangerouslySetInnerHTML={{ __html: currentTemplate || '' }} />
      </div>
    </Row>
  );
});
